import { render, staticRenderFns } from "./reference_art.vue?vue&type=template&id=91baed90&scoped=true&"
import script from "./reference_art.vue?vue&type=script&lang=js&"
export * from "./reference_art.vue?vue&type=script&lang=js&"
import style0 from "./reference_art.vue?vue&type=style&index=0&id=91baed90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91baed90",
  null
  
)

export default component.exports